import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-guest-content',
  templateUrl: './guest-content.component.html',
  styleUrls: ['./guest-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class GuestContentComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
